import { LayoutType } from '../types/layouts.esm.js';

function getDefaultLayout(layouts) {
  var defaultLayout = layouts === null || layouts === void 0 ? void 0 : layouts.find(function (l) {
    return l.type === LayoutType.Default;
  });
  if (!defaultLayout) {
    throw new Error('There should be a default layout');
  }
  return defaultLayout;
}
function getSelectedLayout(layouts) {
  var selectedLayout = layouts === null || layouts === void 0 ? void 0 : layouts.find(function (l) {
    return l.selected;
  });
  if (!selectedLayout) {
    return getDefaultLayout(layouts);
  }
  return selectedLayout;
}

export { getDefaultLayout, getSelectedLayout };
//# sourceMappingURL=get-selected-layout.esm.js.map
